// This file is AUTOGENERATED, do not edit it manually!!!

export const menu = {
    notifications: 'Nastavenia upozornenia',
    portfolios: 'Portfólia',
    reports: 'Správy',
    resourcesPage: 'Zdroje',
    roles: 'Role',
    search: 'Vyhľadávanie',
};
